import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  smsDelivered: (
    <FormattedMessage id="Global.SmsDelivered" defaultMessage="SMS Delivered" />
  ),
  clearFilter: (
    <FormattedMessage id="Global.ClearFilter" defaultMessage="Clear Filters" />
  ),
  noResults: (
    <FormattedMessage
      id="ReportsList.NoResults"
      defaultMessage="No results found."
    />
  ),

  carrierName: (
    <FormattedMessage
      id="ReportsList.CarrierName"
      defaultMessage="Carrier Name"
    />
  ),
  customerName: (
    <FormattedMessage
      id="ReportsList.CustomerName"
      defaultMessage="Customer Name"
    />
  ),
  carrierCountry: (
    <FormattedMessage
      id="ReportsList.CarrierCountry"
      defaultMessage="Carrier Country"
    />
  ),
  customerCountry: (
    <FormattedMessage
      id="ReportsList.CustomerCountry"
      defaultMessage="Customer Country"
    />
  ),
  standardSent: (
    <FormattedMessage
      id="ReportsList.StandardSent"
      defaultMessage="Standard Sent"
    />
  ),
  directSent: (
    <FormattedMessage
      id="ReportsList.DirectSent"
      defaultMessage="Direct Sent"
    />
  ),
  reminderSent: (
    <FormattedMessage
      id="ReportsList.ReminderSent"
      defaultMessage="Reminder Sent"
    />
  ),
  failedMessages: (
    <FormattedMessage
      id="ReportsList.FailedMessages"
      defaultMessage="Failed Messages"
    />
  ),
  gateway: (
    <FormattedMessage id="ReportsList.Gateway" defaultMessage="Gateway" />
  ),
  total: <FormattedMessage id="ReportsList.Total" defaultMessage="Total" />,
  searchingText: (
    <FormattedMessage
      id="ReportsList.SearchingText"
      defaultMessage="Searching..."></FormattedMessage>
  ),
  to: (
    <FormattedMessage
      id="ReportsList.to"
      defaultMessage="to"></FormattedMessage>
  ),
  from: (
    <FormattedMessage
      id="ReportsList.from"
      defaultMessage="From"></FormattedMessage>
  ),
};

export default FormattedMessages;
